module.exports = __webpack_public_path__ + "static/img/brand-01.d83408e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-01.png
// module id = m2gU
// module chunks = 0